"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TRACKER_CONFIG = exports.DEFAULT_POST_PATH = exports.SNOWPLOW_TRACKER_NAME = void 0;
/**
 * This is the name of the tracker that will appear in the cookies.
 * Default is 'sp', however that could be confused with Service Provider so
 * opted to rename to 'snpl'.
 */
exports.SNOWPLOW_TRACKER_NAME = 'snpl';
/**
 * Default POST path used by the Snowplow collector across environments.
 */
exports.DEFAULT_POST_PATH = '/com.angi/yw8';
/**
 * Configuration to be used when initializing the Snowplow Tracker.
 */
exports.DEFAULT_TRACKER_CONFIG = {
    platform: 'web',
    postPath: exports.DEFAULT_POST_PATH,
    cookieName: exports.SNOWPLOW_TRACKER_NAME,
    cookieSameSite: 'Lax',
    respectDoNotTrack: false,
    discoverRootDomain: true,
    contexts: {
        webPage: true,
        session: true,
        browser: true,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RyYWNrZXIvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBOzs7O0dBSUc7QUFDVSxRQUFBLHFCQUFxQixHQUFHLE1BQU0sQ0FBQztBQUU1Qzs7R0FFRztBQUNVLFFBQUEsaUJBQWlCLEdBQUcsZUFBZSxDQUFDO0FBRWpEOztHQUVHO0FBQ1UsUUFBQSxzQkFBc0IsR0FBeUI7SUFDeEQsUUFBUSxFQUFFLEtBQUs7SUFDZixRQUFRLEVBQUUseUJBQWlCO0lBQzNCLFVBQVUsRUFBRSw2QkFBcUI7SUFDakMsY0FBYyxFQUFFLEtBQUs7SUFDckIsaUJBQWlCLEVBQUUsS0FBSztJQUN4QixrQkFBa0IsRUFBRSxJQUFJO0lBQ3hCLFFBQVEsRUFBRTtRQUNOLE9BQU8sRUFBRSxJQUFJO1FBQ2IsT0FBTyxFQUFFLElBQUk7UUFDYixPQUFPLEVBQUUsSUFBSTtLQUNoQjtDQUNKLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../src/tracker/constants.ts